import { InjectionToken } from '@angular/core';
import { Integration } from '@sentry/core';
export const SSR_SENTRY_INTEGRATIONS = new InjectionToken<Integration[]>(
    'SSR_SENTRY_INTEGRATIONS'
);
